import { isEmptyObject } from './isEmptyObject';
import { AUTHORIZATION } from '../constants';
export const createSimplifiedCacheKey = options => {
  if (!options) {
    return null;
  }
  const {
    url,
    query,
    headers,
    variables
  } = options;
  const headersForCacheKey = {
    ...headers
  };
  if (Object.hasOwn(headersForCacheKey, AUTHORIZATION)) {
    delete headersForCacheKey[AUTHORIZATION]; // We do not wan't to store token in cache as it differs on server and client.
  }
  // Return a cache key object with non-empty properties
  const cacheKey = {
    ...(url && {
      url
    }),
    ...(query && {
      query
    }),
    ...(variables && !isEmptyObject(variables) && {
      variables
    }),
    ...(headers && !isEmptyObject(headersForCacheKey) && {
      headers: headersForCacheKey
    })
  };
  return cacheKey;
};
//# sourceMappingURL=createSimplifiedCacheKey.js.map